

(function(){
"use strict";
var guideRoot = document.getElementById("guia-esp");
if(!guideRoot) return;
guideRoot.classList.add("js");
var $ = function(sel,ctx){ return (ctx||guideRoot).querySelector(sel); };
var $$ = function(sel,ctx){ return Array.prototype.slice.call((ctx||guideRoot).querySelectorAll(sel)); };


var toolsMenu = $(".tools-menu"), toolsToggle = $("#tools-menu-toggle"), toolsPanel = $("#tools-menu-panel");
function setToolsMenu(open){
  if(!toolsToggle || !toolsPanel) return;
  toolsToggle.setAttribute("aria-expanded",open ? "true" : "false");
  toolsPanel.hidden = !open;
}
if(toolsMenu && toolsToggle && toolsPanel){
  toolsToggle.addEventListener("click",function(){ setToolsMenu(toolsToggle.getAttribute("aria-expanded") !== "true"); });
  toolsPanel.addEventListener("click",function(){ setToolsMenu(false); });
  document.addEventListener("click",function(event){ if(!toolsMenu.contains(event.target)) setToolsMenu(false); });
  document.addEventListener("keydown",function(event){
    if(event.key === "Escape" && toolsToggle.getAttribute("aria-expanded") === "true"){
      setToolsMenu(false); toolsToggle.focus();
    }
  });
}



var PRODUTOS = [
  {nome:"Garibaldi Espumante Moscatel", url:"/products/espumante-moscatel-garibaldi-750ml", estilo:"moscatel", cor:"branco", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"sobremesas, frutas e panetone"},
  {nome:"Vita Eterna Espumante Moscatel", url:"/products/vita-eterna-espumante-moscatel", estilo:"moscatel", cor:"branco", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"doces e tábuas de queijos"},
  {nome:"Garibaldi Espumante Moscatel Rosé", url:"/products/espumante-moscatel-rose-garibaldi-750ml", estilo:"moscatel", cor:"rose", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"frutas vermelhas e chocolate branco"},
  {nome:"Casa Valduga Naturelle Espumante Moscatel Rosé", url:"/products/espumante-moscatel-rose-naturelle-casa-valduga-750ml", estilo:"moscatel", cor:"rose", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"sobremesas cítricas e frutas"},
  {nome:"Del Grano Espumante Moscatel Rosé", url:"/products/del-grano-espumante-moscatel-rose", estilo:"moscatel", cor:"rose", metodo:"Asti", regiao:"Serra Gaúcha", harmonia:"salada de frutas e pavlova"},
  {nome:"Monte Paschoal Espumante Moscatel Rosé", url:"/products/monte-paschoal-espumante-moscatel-rose", estilo:"moscatel", cor:"rose", metodo:"Asti", regiao:"Farroupilha (RS)", harmonia:"doces natalinos"},
  {nome:"Zanotto Espumante Brut Champenoise", url:"/products/zanotto-espumante-brut-champenoise", estilo:"brut-tradicional", cor:"branco", metodo:"Tradicional", regiao:"Campos de Cima da Serra (RS)", harmonia:"queijos, aves e risotos"},
  {nome:"Casa Valduga Premivm Espumante Nature (caixa c/ 6)", url:"/products/casa-valduga-premivm-espumante-nature-caixa-com-6", estilo:"nature", cor:"branco", metodo:"Tradicional", regiao:"Vale dos Vinhedos (RS)", harmonia:"ostras, sushi e frutos do mar"},
  {nome:"Garibaldi Zero Álcool 0,0% Moscato Rosé", url:"/products/espumante-moscato-rose-zero-alcool-garibaldi-750ml", estilo:"semalcool", cor:"rose", metodo:"Sem álcool", regiao:"Serra Gaúcha", harmonia:"brindes inclusivos e frutas"},
  {nome:"Garibaldi ICE Zero Álcool Espumante Rosé", url:"/products/zero-alcool-ice-rose-garibaldi-750ml", estilo:"semalcool", cor:"rose", metodo:"Sem álcool", regiao:"Serra Gaúcha", harmonia:"dias quentes, com gelo"},
  {nome:"Kit Espumantes 130 Casa Valduga", url:"/products/kit-espumantes-130-casa-valduga", estilo:"kit", cor:"misto", metodo:"Tradicional", regiao:"Vale dos Vinhedos (RS)", harmonia:"presentes e degustações comparativas"}
];
var COLECOES = {
  espumantes:{nome:"Todos os espumantes", url:"/collections/espumantes"},
  proseccos:{nome:"Proseccos brasileiros", url:"/collections/proseccos"},
  semalcool:{nome:"Espumantes sem álcool", url:"/collections/sem-alcool"},
  caixas:{nome:"Caixas de espumantes", url:"/collections/espumantes-em-caixa"},
  minis:{nome:"Mini espumantes", url:"/collections/mini-espumantes"},
  garibaldi:{nome:"Vinícola Garibaldi", url:"/collections/garibaldi"},
  valduga:{nome:"Casa Valduga", url:"/collections/casa-valduga"}
};
function cardProduto(p){
  var productUrl = p.url.indexOf("/")===0 ? "https://espumantesdosul.com.br"+p.url : p.url;
  return '<div class="prod-card">'+
    '<span class="p-ico" aria-hidden="true"><svg width="26" height="40" viewBox="0 0 26 40"><path d="M10 1 h6 v8 c4 3 6 6 6 12 v14 a4 4 0 0 1 -4 4 h-10 a4 4 0 0 1 -4 -4 v-14 c0 -6 2 -9 6 -12 z" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></span>'+
    '<b>'+p.nome+'</b>'+
    '<small>'+p.metodo+' · '+p.regiao+'</small>'+
    '<small>Vai bem com: '+p.harmonia+'</small>'+
    '<a href="'+productUrl+'" target="_blank" rel="noopener" title="Página do produto '+p.nome+'">Conhecer este espumante ↗</a>'+
  '</div>';
}
function porEstilo(estilos, limite){
  var out = [];
  estilos.forEach(function(e){
    PRODUTOS.forEach(function(p){ if(p.estilo===e && out.indexOf(p)<0) out.push(p); });
  });
  return out.slice(0, limite||3);
}


var prog = $("#esp-progress");
function atualizaProgresso(){
  var h = document.documentElement;
  var total = h.scrollHeight - h.clientHeight;
  prog.style.width = (total>0 ? (h.scrollTop/total)*100 : 0) + "%";
}
window.addEventListener("scroll", atualizaProgresso, {passive:true});
atualizaProgresso();


var btnTopo = $("#btn-topo");
window.addEventListener("scroll", function(){
  btnTopo.classList.toggle("visivel", window.scrollY > 600);
}, {passive:true});
btnTopo.addEventListener("click", function(){ window.scrollTo({top:0, behavior:"smooth"}); });


var toc = $("#esp-toc"), tocToggle = $("#toc-toggle");
tocToggle.addEventListener("click", function(){
  var aberto = toc.classList.toggle("aberto");
  tocToggle.setAttribute("aria-expanded", aberto ? "true" : "false");
});
$$("#toc-lista a").forEach(function(a){
  a.addEventListener("click", function(){
    toc.classList.remove("aberto");
    tocToggle.setAttribute("aria-expanded","false");
  });
});
var tocLinks = {};
$$("#toc-lista a").forEach(function(a){ tocLinks[a.getAttribute("href").slice(1)] = a; });
if ("IntersectionObserver" in window){
  var visiveis = {};
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ visiveis[en.target.id] = en.isIntersecting; });
    var atual = null;
    $$("main section.cap").some(function(s){ if(visiveis[s.id]){ atual = s.id; return true; } return false; });
    if(atual){
      $$("#toc-lista a").forEach(function(a){ a.classList.remove("active"); });
      if(tocLinks[atual]) tocLinks[atual].classList.add("active");
    }
  }, {rootMargin:"-15% 0px -70% 0px"});
  $$("main section.cap").forEach(function(s){ obs.observe(s); });
}


var busca = $("#esp-busca"), buscaMsg = $("#busca-result");
if(busca){
  busca.addEventListener("input", function(){
    var q = busca.value.trim().toLowerCase();
    var achados = 0;
    $$("#toc-lista a").forEach(function(a){
      var id = a.getAttribute("href").slice(1);
      var sec = document.getElementById(id);
      var ok = !q || (sec && sec.textContent.toLowerCase().indexOf(q) > -1);
      a.parentElement.style.display = ok ? "" : "none";
      if(ok && q) achados++;
    });
    buscaMsg.textContent = q ? (achados + " capítulo(s) mencionam “" + busca.value.trim() + "”") : "";
  });
}


var raiz = $("#guia-esp"), tamanhos = ["fs-sm","","fs-lg","fs-xl"], fsIdx = 1;
function aplicaFs(){
  raiz.classList.remove("fs-sm","fs-lg","fs-xl");
  if(tamanhos[fsIdx]) raiz.classList.add(tamanhos[fsIdx]);
}
$("#fs-mais").addEventListener("click", function(){ if(fsIdx<3){ fsIdx++; aplicaFs(); } });
$("#fs-menos").addEventListener("click", function(){ if(fsIdx>0){ fsIdx--; aplicaFs(); } });


$("#btn-imprimir").addEventListener("click", function(){ window.print(); });
$("#btn-compartilhar").addEventListener("click", function(){
  var dados = {title:document.title, url:location.href};
  if(navigator.share){ navigator.share(dados).catch(function(){}); }
  else if(navigator.clipboard){
    navigator.clipboard.writeText(location.href).then(function(){
      alert("Link do guia copiado para a área de transferência!");
    });
  }
});


$$(".copy-link").forEach(function(b){
  b.addEventListener("click", function(){
    var url = location.origin + location.pathname + "#" + b.getAttribute("data-alvo");
    function feito(){
      var t=b.textContent, lbl=b.getAttribute("aria-label");
      b.textContent="Copiado!";
      if(lbl) b.setAttribute("aria-label","Link copiado");
      setTimeout(function(){ b.textContent=t; if(lbl) b.setAttribute("aria-label",lbl); },1600);
    }
    if(navigator.clipboard){ navigator.clipboard.writeText(url).then(feito); }
    else { window.prompt("Copie o link:", url); }
  });
});


// Tooltips de jargão: no desktop aparecem no hover/foco (CSS); no toque, o clique fixa/oculta.
function posicionaTip(wrap){
  var btn = wrap.querySelector(".tt"), bubble = wrap.querySelector(".tt-bubble");
  if(!btn || !bubble) return;
  // Mantém a bolha dentro da viewport, ancorada ao gatilho quando cabe.
  var margem = 8;
  var vw = document.documentElement.clientWidth;
  var largura = Math.min(280, vw * 0.8);
  var gatilhoLeft = btn.getBoundingClientRect().left;
  var alvo = Math.min(Math.max(margem, gatilhoLeft), vw - margem - largura);
  bubble.style.left = (alvo - gatilhoLeft) + "px";
  bubble.style.right = "auto";
}
$$(".tt").forEach(function(btn){
  var wrap = btn.closest(".tt-wrap");
  if(!wrap) return;
  btn.addEventListener("mouseenter", function(){ posicionaTip(wrap); });
  btn.addEventListener("focus", function(){ posicionaTip(wrap); });
  btn.addEventListener("click", function(e){
    e.stopPropagation();
    var abrindo = !wrap.classList.contains("tt-open");
    $$(".tt-wrap.tt-open").forEach(function(w){ if(w!==wrap) w.classList.remove("tt-open"); });
    if(abrindo) posicionaTip(wrap);
    wrap.classList.toggle("tt-open", abrindo);
  });
});
document.addEventListener("click", function(e){
  $$(".tt-wrap.tt-open").forEach(function(w){ if(!w.contains(e.target)) w.classList.remove("tt-open"); });
});
document.addEventListener("keydown", function(e){
  if(e.key === "Escape"){
    $$(".tt-wrap.tt-open").forEach(function(w){
      w.classList.remove("tt-open");
      var b = w.querySelector(".tt"); if(b) b.focus();
    });
  }
});


var REGUA = {
  nature:{t:"Nature · até 3 g/L", d:"O extremo seco: nenhuma sensação de doçura, acidez em primeiro plano, precisão e mineralidade. Perfeito com ostras, sushi e frutos do mar. Para paladares que amam vinhos bem secos."},
  extrabrut:{t:"Extra Brut · 3,1 a 8 g/L", d:"Praticamente seco, tenso e vibrante. Extremamente gastronômico: peixes, frituras finas, saladas e carnes brancas. Para quem quer secura com um fio de redondeza."},
  brut:{t:"Brut · 8,1 a 15 g/L", d:"Seco com uma pontinha imperceptível de dulçor que arredonda a acidez. É o estilo mais versátil e mais consumido: funciona como aperitivo e acompanha a refeição inteira. Indicado para quase todos os públicos e ocasiões."},
  seco:{t:"Sec (Seco) · 15,1 a 20 g/L", d:"Dulçor sutil e perceptível, corpo macio. Brilha com pratos agridoces e cozinha asiática. Boa ponte para quem acha o Brut seco demais."},
  demisec:{t:"Demi-Sec (Meio Seco) · 20,1 a 60 g/L", d:"Claramente adocicado, envolvente e frutado. Companheiro de sobremesas pouco doces, queijos azuis e frutas. Sirva bem gelado (4–6 °C)."},
  doce:{t:"Doce · acima de 60 g/L", d:"Doçura intensa e licorosa. Território das sobremesas elaboradas. No Brasil, o dulçor querido do dia a dia costuma vir do Moscatel (mínimo 20 g/L de açúcar natural da uva, pelo método Asti)."}
};
$$(".regua button").forEach(function(b){
  b.addEventListener("click", function(){
    $$(".regua button").forEach(function(x){ x.setAttribute("aria-pressed","false"); });
    b.setAttribute("aria-pressed","true");
    var info = REGUA[b.getAttribute("data-regua")];
    $("#rd-titulo").textContent = info.t;
    $("#rd-texto").textContent = info.d;
  });
});


var filtroAtivo = {docura:"todos", metodo:"todos"};
function aplicaFiltros(){
  var n = 0;
  $$(".estilo-card").forEach(function(c){
    var okD = filtroAtivo.docura==="todos" || (c.getAttribute("data-docura")||"").split(" ").indexOf(filtroAtivo.docura)>-1;
    var okM = filtroAtivo.metodo==="todos" || (c.getAttribute("data-metodo")||"").split(" ").indexOf(filtroAtivo.metodo)>-1;
    var mostra = okD && okM;
    c.hidden = !mostra;
    if(mostra) n++;
  });
  $("#filtro-status").textContent = n + " estilo(s) exibido(s).";
}
$$(".filtros .chip").forEach(function(ch){
  ch.addEventListener("click", function(){
    var grupo = ch.getAttribute("data-filtro");
    $$('.filtros .chip[data-filtro="'+grupo+'"]').forEach(function(x){ x.setAttribute("aria-pressed","false"); });
    ch.setAttribute("aria-pressed","true");
    filtroAtivo[grupo] = ch.getAttribute("data-valor");
    aplicaFiltros();
  });
});


var HARM = {
  canapes:{estilo:"Brut", just:"Acidez e borbulha renovam o paladar entre mordidas salgadas e untuosas.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  "queijos-frescos":{estilo:"Prosecco ou Brut leve", just:"Delicadeza com delicadeza: fruta fresca acompanha queijos suaves e folhas.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"proseccos"},
  embutidos:{estilo:"Extra Brut ou Brut Rosé", just:"Sal e gordura pedem acidez firme; a fruta vermelha do rosé conversa com embutidos.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  ostras:{estilo:"Nature (Blanc de Blancs)", just:"Mineralidade e secura espelham o iodado da ostra sem sobrepor nada.", temp:"7–9 °C", metodo:"Tradicional", prods:["nature"], col:"espumantes"},
  camarao:{estilo:"Brut ou Brut Rosé", just:"Corpo suficiente para crustáceos grelhados, frescor para o mar.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  sushi:{estilo:"Brut cítrico ou Nature", just:"Acidez limpa o paladar entre peças; delicadeza respeita o peixe cru.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["nature"], col:"proseccos"},
  "peixe-frito":{estilo:"Extra Brut", just:"A borbulha faz o papel do limão: corta a fritura e refresca.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"espumantes"},
  "peixe-grelhado":{estilo:"Brut ou Blanc de Blancs", just:"Frescor e elegância acompanham a delicadeza do peixe no ponto.", temp:"6–8 °C", metodo:"Tradicional ou Charmat", prods:["brut-tradicional"], col:"espumantes"},
  frango:{estilo:"Brut ou Brut Rosé", just:"Versatilidade para assados e grelhados de sabor médio.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  pato:{estilo:"Blanc de Noirs ou rosé estruturado", just:"Carnes mais gordas e saborosas pedem corpo e fruta vermelha.", temp:"8–10 °C", metodo:"Tradicional", prods:["brut-tradicional"], col:"valduga"},
  "carne-leve":{estilo:"Rosé estruturado ou Blanc de Noirs", just:"Estrutura para a proteína, acidez para o azeite e o sal do carpaccio.", temp:"8–10 °C", metodo:"Tradicional", prods:[], col:"espumantes"},
  "massa-branca":{estilo:"Brut", just:"A mousse cremosa espelha o molho; a acidez impede que canse.", temp:"6–8 °C", metodo:"Tradicional ou Charmat", prods:["brut-tradicional"], col:"espumantes"},
  "massa-tomate":{estilo:"Brut Rosé", just:"Acidez do tomate encontra acidez do vinho; fruta vermelha com fruta vermelha.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"espumantes"},
  risoto:{estilo:"Método tradicional Brut", just:"Notas de autólise ecoam o umami de cogumelos e queijos; cítricos pedem Nature.", temp:"8–10 °C", metodo:"Tradicional", prods:["brut-tradicional","nature"], col:"valduga"},
  pizza:{estilo:"Brut ou Brut Rosé", just:"Massa, queijo e molho: o trio pede acidez, borbulha e fruta.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"espumantes"},
  "pizza-doce":{estilo:"Moscatel", just:"Doçura compatível com banana, chocolate e canela.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  frituras:{estilo:"Brut ou Extra Brut bem gelado", just:"Acidez + carbonatação 'raspam' a gordura e devolvem o apetite.", temp:"6–8 °C", metodo:"Charmat", prods:["brut-tradicional"], col:"espumantes"},
  churrasco:{estilo:"Brut Rosé", just:"Fruta vermelha e acidez para linguiça, frango e cortes suínos; estrutura para a carne.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:[], col:"espumantes"},
  feijoada:{estilo:"Extra Brut ou Brut Rosé", just:"Prato intenso e gordo pede contraponto seco, gelado e refrescante.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"espumantes"},
  moqueca:{estilo:"Brut Rosé ou Sec", just:"Dendê e pimenta se acalmam com fruta e um toque de dulçor.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"espumantes"},
  paodequeijo:{estilo:"Brut da Serra Gaúcha", just:"Herança colonial com espumante da Serra: afinidade histórica e sensorial.", temp:"6–8 °C", metodo:"Charmat ou Tradicional", prods:["brut-tradicional"], col:"garibaldi"},
  asiatica:{estilo:"Sec, Demi-Sec ou Moscatel", just:"Quanto mais pimenta e açúcar no prato, mais dulçor no espumante.", temp:"4–6 °C", metodo:"Charmat ou Asti", prods:["moscatel"], col:"espumantes"},
  "queijos-moles":{estilo:"Brut de método tradicional", just:"Autólise conversa com a casca florida; acidez corta a cremosidade.", temp:"8–10 °C", metodo:"Tradicional", prods:["brut-tradicional"], col:"valduga"},
  "queijos-duros":{estilo:"Extra Brut ou Nature", just:"Sal e cristais de maturação pedem secura e acidez.", temp:"7–9 °C", metodo:"Tradicional", prods:["nature"], col:"espumantes"},
  "queijo-azul":{estilo:"Demi-Sec ou Moscatel", just:"Doce com salgado: o contraste clássico que suaviza o mofo azul.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  "queijo-colonial":{estilo:"Brut", just:"Vizinhos de origem na Serra, parceiros naturais de mesa.", temp:"6–8 °C", metodo:"Charmat", prods:[], col:"garibaldi"},
  frutas:{estilo:"Moscatel", just:"Aromas de uva, flores e mel abraçam a fruta fresca; álcool leve mantém a tarde leve.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  tortas:{estilo:"Demi-Sec ou Moscatel", just:"Doçura compatível com a sobremesa; acidez da fruta ajuda o equilíbrio.", temp:"4–6 °C", metodo:"Asti ou Charmat", prods:["moscatel"], col:"espumantes"},
  "coco-chocolate":{estilo:"Moscatel (inclusive rosé)", just:"Só um espumante realmente doce acompanha coco e chocolate sem ficar amargo.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  "choc-amargo":{estilo:"Moscatel rosé (desafio!)", just:"Chocolate amargo é difícil para espumantes; se insistir, fruta vermelha e dulçor — ou prefira um fortificado.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"espumantes"},
  natal:{estilo:"Moscatel", just:"O par natalino por excelência: panetone, rabanada e frutas cristalizadas.", temp:"4–6 °C", metodo:"Asti", prods:["moscatel"], col:"caixas"}
};
var harmSel = $("#harm-prato"), harmRes = $("#harm-resultado");
if(harmSel){
  harmSel.addEventListener("change", function(){
    var h = HARM[harmSel.value];
    if(!h){ harmRes.innerHTML=""; return; }
    var prods = porEstilo(h.prods, 3);
    var html = '<div class="dica"><p><strong>Estilo recomendado:</strong> '+h.estilo+'</p>'+
      '<p><strong>Por quê:</strong> '+h.just+'</p>'+
      '<p><strong>Temperatura:</strong> '+h.temp+' · <strong>Método sugerido:</strong> '+h.metodo+'</p></div>';
    if(prods.length){
      html += '<p style="font-size:.9em"><strong>Sugestões no site</strong> (recomendação editorial — confirme detalhes na página de cada produto):</p><div class="prod-grid">';
      prods.forEach(function(p){ html += cardProduto(p); });
      html += '</div>';
    }
    var col = COLECOES[h.col];
    if(col){ html += '<p><a href="'+col.url+'" title="'+col.nome+'">Ver mais opções em: '+col.nome+' →</a></p>'; }
    harmRes.innerHTML = html;
  });
}


var quizForm = $("#quiz-form"), quizRes = $("#quiz-resultado");
var qAtual = 1, TOTALQ = 8;
function mostraQ(n){
  $$(".quiz-q").forEach(function(q){ q.classList.toggle("ativa", +q.getAttribute("data-q")===n); });
  $("#quiz-voltar").hidden = n<=1;
  $("#quiz-avancar").textContent = (n===TOTALQ) ? "Ver meu resultado ✓" : "Avançar →";
  $("#quiz-prog").style.width = ((n-1)/TOTALQ*100) + "%";
}
function resposta(n){
  var el = quizForm.querySelector('input[name="q'+n+'"]:checked');
  return el ? el.value : null;
}
$("#quiz-avancar").addEventListener("click", function(){
  if(!resposta(qAtual)){
    alert("Escolha uma opção para continuar.");
    return;
  }
  if(qAtual < TOTALQ){ qAtual++; mostraQ(qAtual); }
  else { calculaQuiz(); }
});
$("#quiz-voltar").addEventListener("click", function(){ if(qAtual>1){ qAtual--; mostraQ(qAtual); } });

function calculaQuiz(){
  var r = {};
  for(var i=1;i<=TOTALQ;i++){ r["q"+i]=resposta(i); }
  // pontuação de doçura: q1, q2, q3(uva), q4(sobremesa)
  var doce = 0;
  if(r.q1==="doce") doce+=2; if(r.q1==="meio") doce+=1;
  if(r.q2==="doce") doce+=2; if(r.q2==="meio") doce+=1;
  if(r.q3==="uva") doce+=2;
  if(r.q4==="sobremesa") doce+=1;
  var semAlcool = r.q7==="sem";
  var complexo = r.q6==="complexo" || r.q3==="pao";
  var rose = r.q5==="rose";

  var perfil, docura, metodo, estilo, harmonias, ocasioes, estilosProd, colecoes;
  if(semAlcool){
    perfil = "Brinde inclusivo";
    docura = "Frutado, geralmente adocicado";
    metodo = "Elaborações 0,0% (confira o rótulo)";
    estilo = rose ? "Espumante sem álcool rosé" : "Espumante sem álcool";
    harmonias = "frutas, saladas, sobremesas leves e petiscos de tarde";
    ocasioes = "gestações, direção, escolha pessoal — qualquer brinde em que todos participam";
    estilosProd = ["semalcool"];
    colecoes = ["semalcool"];
  } else if(doce >= 4){
    perfil = "Alma doce e aromática";
    docura = "Doce (Moscatel) ou Demi-Sec";
    metodo = "Asti";
    estilo = rose ? "Moscatel rosé" : "Moscatel";
    harmonias = "sobremesas, frutas, queijos azuis, panetone e pratos levemente picantes";
    ocasioes = "brunches, tardes de verão, Natal, festas e mesas de doces";
    estilosProd = ["moscatel"];
    colecoes = ["espumantes"];
  } else if(doce >= 2){
    perfil = "Equilibrista frutado";
    docura = "Brut a Sec — seco com maciez";
    metodo = "Charmat";
    estilo = rose ? "Brut Rosé ou Sec rosé" : "Brut ou Sec de perfil frutado";
    harmonias = "pizzas, massas ao tomate, frango assado, comida asiática suave";
    ocasioes = "almoços de fim de semana, encontros informais, churrasco";
    estilosProd = ["brut-tradicional","moscatel"];
    colecoes = ["espumantes","proseccos"];
  } else if(complexo){
    perfil = "Explorador de profundidade";
    docura = "Nature a Brut — o mais seco, melhor";
    metodo = "Tradicional (busque menções a 'sur lie')";
    estilo = rose ? "Brut Rosé de método tradicional ou Blanc de Noirs" : "Nature, Extra Brut ou Blanc de Blancs";
    harmonias = "ostras, risotos de cogumelo, queijos de casca florida, aves com molhos";
    ocasioes = "jantares gastronômicos, presentes especiais, celebrações íntimas";
    estilosProd = ["nature","brut-tradicional","kit"];
    colecoes = ["valduga","espumantes"];
  } else {
    perfil = "Frescor em primeiro lugar";
    docura = "Brut ou Extra Brut";
    metodo = "Charmat";
    estilo = rose ? "Brut Rosé" : "Brut jovem ou Prosecco brasileiro";
    harmonias = "aperitivos, frituras, sushi, saladas e frutos do mar";
    ocasioes = "praia, piscina, happy hour, consumo cotidiano";
    estilosProd = ["brut-tradicional"];
    colecoes = ["proseccos","espumantes"];
  }
  if(r.q8==="presente" && !semAlcool){ estilosProd.unshift("kit"); }

  var prods = porEstilo(estilosProd, 4);
  var html = '<h4>Seu perfil: '+perfil+'</h4>'+
    '<p>Com base nas suas respostas, um espumante <strong>'+estilo+'</strong> provavelmente combina com você. Vale experimentar rótulos na faixa <strong>'+docura+'</strong>, de preferência elaborados pelo método <strong>'+metodo+'</strong>.</p>'+
    '<p><strong>Harmonizações para começar:</strong> '+harmonias+'.<br><strong>Ocasiões com a sua cara:</strong> '+ocasioes+'.</p>';
  var links = [];
  colecoes.forEach(function(c){ if(COLECOES[c]) links.push('<a href="https://espumantesdosul.com.br'+COLECOES[c].url+'" target="_blank" rel="noopener" title="'+COLECOES[c].nome+'">'+COLECOES[c].nome+'</a>'); });
  if(links.length){ html += '<p><strong>Categorias sugeridas:</strong> '+links.join(" · ")+'</p>'; }
  if(prods.length){
    html += '<p><strong>Rótulos do site que valem a prova</strong> (sugestão editorial, não verdade absoluta — confirme os detalhes na página de cada produto):</p><div class="prod-grid">';
    prods.forEach(function(p){ html += cardProduto(p); });
    html += '</div>';
  }
  html += '<div class="acoes"><button type="button" class="btn btn-outline" id="quiz-reset">Refazer o quiz</button></div>';
  quizForm.style.display = "none";
  $("#quiz-prog").style.width = "100%";
  quizRes.style.display = "block";
  quizRes.innerHTML = html;
  $("#quiz-reset").addEventListener("click", resetQuiz);
  quizRes.scrollIntoView({behavior:"smooth", block:"nearest"});
}
function resetQuiz(){
  quizForm.reset();
  qAtual = 1;
  quizForm.style.display = "";
  quizRes.style.display = "none";
  quizRes.innerHTML = "";
  mostraQ(1);
}
var btnRefazer = $("#refazer-quiz");
if(btnRefazer){
  btnRefazer.addEventListener("click", function(){
    resetQuiz();
    document.getElementById("quiz").scrollIntoView({behavior:"smooth"});
  });
}
mostraQ(1);


$("#c-calcular").addEventListener("click", function(){
  var conv = Math.max(1, parseInt($("#c-convidados").value,10) || 0);
  var dur = Math.max(1, parseFloat($("#c-duracao").value) || 0);
  var tipo = $("#c-tipo").value;
  var outras = $("#c-outras").value;
  var perfil = $("#c-perfil").value;
  var mlGarrafa = parseInt($("#c-garrafa").value,10);
  var margem = parseFloat($("#c-margem").value) || 1.10;
  var caixas = $("#c-caixas").checked;

  // consumo base em taças de ~130 ml por pessoa/hora, conforme o tipo de evento
  var taxa = {brinde:0, aperitivo:1.0, festa:0.8, jantar:0.7, casamento:0.9, formatura:1.0, corporativo:0.6}[tipo];
  var taças;
  if(tipo==="brinde"){ taças = 1; }
  else {
    taças = taxa * dur;
    // primeira hora consome mais; horas longas, menos
    if(dur>4) taças = taxa*4 + taxa*0.5*(dur-4);
  }
  var fatorOutras = {sim:0.6, poucas:0.8, nao:1.0}[outras];
  var fatorPerfil = {leve:0.8, medio:1.0, alto:1.25}[perfil];
  if(tipo!=="brinde") taças = taças * fatorOutras * fatorPerfil;
  var mlTotal = conv * taças * 130;
  var garrafas = Math.ceil(mlTotal * margem / mlGarrafa);
  if(tipo==="brinde"){ garrafas = Math.ceil(conv * 140 * margem / mlGarrafa); }
  garrafas = Math.max(1, garrafas);
  var exibidas = garrafas;
  var notaCaixa = "";
  if(caixas && mlGarrafa>=660){
    exibidas = Math.ceil(garrafas/6)*6;
    notaCaixa = " (" + (exibidas/6) + " caixa(s) de 6)";
  }
  var tacasFisicas = Math.ceil(conv * 1.15); // taças + reposição
  var gelo = Math.ceil(exibidas * 1.2); // ~1,2 kg por garrafa em baldes
  var caixasQtd = mlGarrafa>=660 ? Math.ceil(exibidas/6) : 0;
  var totalLitros = Math.round(exibidas * mlGarrafa / 100) / 10;
  var estilos = (tipo==="casamento"||tipo==="formatura")
    ? "Brut para a festa + Moscatel para os doces"
    : (tipo==="jantar" ? "método tradicional para os pratos e Moscatel para a sobremesa" : "Brut como base, com algumas garrafas de Moscatel e rosé para variar");

  $("#c-resultado").innerHTML =
    '<div class="dica"><h3>Planejamento estimado do evento</h3><div class="calc-summary">'+
    '<div class="calc-stat"><b>'+exibidas+'</b>garrafas de '+mlGarrafa+' ml</div>'+
    '<div class="calc-stat"><b>'+totalLitros+' L</b>volume total</div>'+
    '<div class="calc-stat"><b>'+tacasFisicas+'</b>taças disponíveis</div>'+
    '<div class="calc-stat"><b>'+gelo+' kg</b>gelo para baldes</div></div>'+
    '<p><strong>Consumo calculado:</strong> aproximadamente '+Math.round(taças*10)/10+' taça(s) por convidado. '+
    (caixasQtd ? '<strong>Compra em caixas:</strong> '+caixasQtd+' caixa(s) de 6. ' : '')+
    (exibidas!==garrafas ? 'O cálculo bruto foi de '+garrafas+' garrafas e foi arredondado para caixas fechadas.' : '')+'</p>'+
    '<p><strong>Estilos sugeridos:</strong> '+estilos+'.</p>'+
    '<p><small>⚠️ Cálculo estimativo, baseado em médias de consumo de adultos. Considere o perfil real dos seus convidados e ajuste. Para compras em volume, veja as <a href="/collections/espumantes-em-caixa" title="Caixas de espumantes">caixas de espumantes</a>; para brindes individuais, os <a href="/collections/mini-espumantes" title="Mini espumantes">minis de 187 ml</a>.</small></p></div>';
});


$("#fd-limpar").addEventListener("click", function(){
  $$("#ficha-degustacao input, #ficha-degustacao textarea, #ficha-degustacao select").forEach(function(c){ c.value=""; });
});
$("#fd-imprimir").addEventListener("click", function(){
  document.body.classList.add("print-ficha");
  window.print();
  setTimeout(function(){ document.body.classList.remove("print-ficha"); }, 500);
});
window.addEventListener("afterprint", function(){ document.body.classList.remove("print-ficha"); });


var gBusca = $("#glossario-busca"), gStatus = $("#glossario-status");
if(gBusca){
  gBusca.addEventListener("input", function(){
    var q = gBusca.value.trim().toLowerCase();
    var n = 0;
    $$("#glossario-lista .g-item").forEach(function(it){
      var ok = !q || it.textContent.toLowerCase().indexOf(q)>-1;
      it.style.display = ok ? "" : "none";
      if(ok) n++;
    });
    gStatus.textContent = q ? n + " termo(s) encontrado(s)" : "";
  });
}



$$('a[href^="/collections/"],a[href^="/products/"],a[href^="/blogs/"]').forEach(function(link){
  link.href = "https://espumantesdosul.com.br" + link.getAttribute("href");
  link.target = "_blank";
  link.rel = "noopener";
});

})();

